import React from "react"

// ---------------------------------------------------------

import { getAwardsData } from "../lib/api"

// ---------------------------------------------------------

import AwardsTemplate from "../templates/awards"

// ---------------------------------------------------------

export async function getStaticProps() {
  let data = await getAwardsData()

  return {
    props: { data }
  }
}

// ---------------------------------------------------------

const AwardsPage = ({ data }) => {
  const pageHeading = "Awards & Achievements"
  const pageMeta =
    "#360 on the Inc 5000, Comparably Best Company Cultures two years in a row, SIIA CODiE Best CDP"

  return (
    <AwardsTemplate data={data} pageTitle="Awards" excerpt={pageMeta} pageHeading={pageHeading} />
  )
}

export default AwardsPage
